// extracted by mini-css-extract-plugin
export default {"ConsentForm":"Consent_ConsentForm__YhjGt","FormError":"Consent_FormError__uHECK"};